<template>
  <!--  :key="elementIndex"-->
  <div
    v-if="getImageType =='SVGImage' || (getImageType && getImageType.indexOf('FDICText') !== -1) || (getImageType && getImageType.indexOf('FDICLogo') !== -1)"
    :id="elementId"
    :data-elementindex="getElementIndex"
    :style="getShapeStyles"
    :data-translateX="transformX"
    :data-translateY="transformY"
    :data-rotate="rotateAngle"
    :class="['target ']"
    class="position-absolute d-flex object-add"
    data-type="shape">
    <div
      ref="svgDiv"
      :style="getShapeTransformStyles"
      :data-hflip="isHFlipped ? -1 : 1"
      :data-vflip="isVFlipped ? -1 : 1"
      class="svg-height"
      v-html="getSvgContent"

    />
  </div>
  <div
    v-else
    :id="elementId"
    :data-rotate="rotateAngle"
    :data-elementindex="getElementIndex"
    :style="[getStylesNew, getMaskStyle]"
    :data-translateX="transformX"
    :data-translateY="transformY"
    :class="getClass"
    :data-subtype="objectProps.ImageType"
    :data-scalex="objectProps.scaleX"
    :data-scaley="objectProps.scaleY"
    :data-blur-edges-distance="getBlurEdgesDistance"
    class="position-absolute d-flex image-container"
    data-type="image">
    <div
      :style="getCornerClipStyle"
      class="corner-clip">
      <img
        :src="imageURL"
        :style="getImageStyles"
        :data-highImage="imageURLHighResPath"
        :data-hflip="isHFlipped ? -1 : 1"
        :data-vflip="isVFlipped ? -1 : 1"
        width="100%"
      >
      <div
        :style="getTintStyle"
        class="tint-div"/>
      <div
        :style="getVignetteStyle"
        class="vignette-div" />
    </div>
  </div>
</template>
<script>
import EventBus from '@/EventBus';
import ApplicationEventTypes from '@/mixins/ApplicationEventTypes';
import { blurMaskCache, getBlurMaskBlob } from '@/components/Helper';
import { uuid } from 'vue-uuid';

export default {
  name:  'ImageComponent',
  props: {
    objectProps: {
      type:    Object,
      default: {},
    },
    isGroupChild: { type: Boolean, default: false },
    elementIndex: {
      type:    Number,
      default: 0,
    },
    isRenderingPagePanel: {
      type:    Boolean,
      default: false,
    },
    isAnimationInProgress: {
      type:    Boolean,
      default: false,
    },
  },
  data() {
    return {
      generatedMask: null,
      instanceId:    '',
      isCircularCrop: 0,
      cornerRadius:   0,
    };
  },
  computed: {
    getAnimationStyle() {
      return !!((this.objectProps.animation.style.includes('photoZom') || this.objectProps.animation.style.includes('photoRise') || this.objectProps.animation.style.includes('photoFlow')));
    },
    elementId:   ({ objectProps }) => objectProps.Id,
    width:       ({ objectProps }) => objectProps.Width,
    height:      ({ objectProps }) => objectProps.Height,
    transformX:  ({ objectProps }) => objectProps.X,
    transformY:  ({ objectProps }) => objectProps.Y,
    rotateAngle: ({ objectProps }) => objectProps.RotateDegree,
    sortOrder:   ({ objectProps }) => objectProps.PdfSortOrder,
    effects:     ({ objectProps }) => objectProps.effects,
    imageBorderRadius() {
      const ratio = Number(this.objectProps.cornerRadius / 2) || 0;
      if (ratio > 0) {
        return '0px';
      }
      if (this.objectProps.croppedSrc !== 'none' && this.objectProps.circleCrop) {
        return '50%';
      }
      return '0px';
    },
    cornerClipPath() {
      const ratio = Math.min(Number(this.objectProps.cornerRadius / 2) || 0, 1);
      const w = Number(this.width) || 0;
      const h = Number(this.height) || 0;
      if (ratio <= 0 || w <= 0 || h <= 0) {
        return '';
      }
      const radius = ratio * 0.5 * Math.min(w, h);
      return `inset(0 round ${radius}px)`;
    },
    getCornerClipStyle() {
      return {
        position: 'absolute',
        top:      '0',
        right:    '0',
        bottom:   '0',
        left:     '0',
        overflow: 'hidden',
        clipPath: this.cornerClipPath || 'none',
      };
    },
    isVisible:   ({ objectProps }) => objectProps.IsVisible,
    locked:      ({ objectProps }) => objectProps.locked,

    isHFlipped() {
      try {
        return JSON.parse(this.objectProps.IsHFlipped);
      } catch (e) {
        return false;
      }
    },

    isVFlipped() {
      try {
        return JSON.parse(this.objectProps.IsVFlipped);
      } catch (e) {
        return false;
      }
    },
    imageURL() {
      let url = this.objectProps.croppedSrc === 'none' ? this.objectProps.DefaultImageUrl : this.objectProps.croppedSrc;
      if (url === undefined || url === 'undefined' || url === null) {
        url = this.objectProps.AlternativeImageUrls[0];
      }
      return url;
    },
    getImageType() {
      return this.objectProps.ImageType;
    },
    getSvgContent() {
      const content = this.objectProps.SvgProperty && this.objectProps.SvgProperty.content;
      if (!content) { return ''; }

      let svg = content;
      const objectId = this.objectProps.Id;
      if (this.isAnimationInProgress && objectId) {
        svg = svg.replaceAll(objectId, `${objectId}_anim`);
      }

      const uniqueGradientId = `gradient-${objectId || 'svg'}-${this.instanceId}`;
      return svg
        .replace(/id=(["'])gradient-[^"']+\1/g, `id=$1${uniqueGradientId}$1`)
        .replace(/url\(\s*#gradient-[^)]+\)/g, `url(#${uniqueGradientId})`);
    },
    imageURLHighResPath() {
      if (this.objectProps.HighResPath && this.objectProps.HighResPath !== 'undefined') {
        if (this.objectProps.croppedHighResPath !== 'none' && this.objectProps.croppedHighResPath != 'undefined') {
          return this.objectProps.croppedHighResPath;
        }
        return this.objectProps.HighResPath;
      }
      return this.objectProps.DefaultImageUrl;
    },
    getShapeTransformStyles() {
      const {
        scaleX, scaleY, Height, Width,
      } = this.objectProps;
      const flipX = this.isHFlipped ? -1 : 1;
      const flipY = this.isVFlipped ? -1 : 1;

      return {
        transform: `scale(${flipX},${flipY})`,
        height:    `${Height * scaleY}px`,
        width:     `${Width * scaleX}px`,
      };
    },
    getShapeStyles() {
      const {
        X, Y, RotateDegree, scaleX, scaleY, Width, Height, Alpha = 100, circleCrop, shadow, effect,
      } = this.objectProps;

      const isShadow = effect && (effect === 'shadow');
      let filter     = 'none';
      if (isShadow) {
        const initialDistance = 0.04; // Default distance for shadow effect
        const initailAngle    = 45; // Default angle for shadow effect
        const initailBlur     = 0.1; // Default blur for shadow effect
        const scaledDistance  = (isShadow && shadow && typeof shadow.distance != 'undefined' ? parseFloat(shadow.distance) : initialDistance) * Math.max(this.objectProps.Height, this.objectProps.Width);
        const radians         = ((isShadow && shadow && shadow.angle ? shadow.angle : initailAngle) * Math.PI) / 180;
        const shadowOffsetX   = scaledDistance * Math.cos(radians);
        const shadowOffsetY   = scaledDistance * Math.sin(radians);
        filter                = `drop-shadow(${shadowOffsetX}px ${shadowOffsetY}px ${(isShadow && shadow && (typeof shadow.blur !== 'undefined') ? shadow.blur : initailBlur) * 40}px ${isShadow && shadow && shadow.color ? shadow.color : '#846C63'})`;
      }
      const pointerEvents = (this.locked) ? 'none' : 'all';

      return {
        transform:       `rotate(${RotateDegree}deg) scale(${scaleX},${scaleY})`,
        backgroundColor: this.getShapeType === 'rectangle' ? this.objectProps.SvgProperty.DefaultColor : '',
        height:          Height !== 0 ? `${Height}px` : 'auto',
        width:           Width !== 0 ? `${Width}px` : 'auto',
        zIndex:          this.objectProps.PdfSortOrder,
        display:         this.objectProps.IsVisible ? 'block !important' : 'none !important',
        opacity:         parseFloat(Alpha) / 100,
        top:             `${Y}px`,
        left:            `${X}px`,
        transformOrigin: 'top left',
        filter,
        pointerEvents,
      };
    },
    getStylesNew() {
      const {
        vignette, transparency, brightness, saturation, contrast, blur,
      } = this.effects;

      const {
        effect, shadow, outline, blurEdges,
      } = this.objectProps;

      const isShadow      = effect && (effect === 'shadow');
      const isOutline     = effect && (effect === 'outline');
      const isBlurEdges   = effect && (effect === 'blurEdges');
      const pointerEvents = (this.locked) ? 'none' : 'all';
      const borderRadius = this.imageBorderRadius;

      const basicImageProperties = {
        transform:       this.getTransformCSS,
        top:             `${this.transformY}px`,
        left:            `${this.transformX}px`,
        height:          `${this.height}px`,
        width:           `${this.width}px`,
        zIndex:          this.sortOrder,
        visibility:      this.isVisible ? 'visible' : 'hidden',
        opacity:         `${transparency.value / 100}`,
        overflow:        'hidden',
        transformOrigin: 'top left',
        borderRadius,
        pointerEvents,
        clipPath: 'none',
      };

      if (basicImageProperties.opacity === '1') {
        delete basicImageProperties.opacity;
      }

      // === Build filter string ===
      const filters = [];

      if (brightness.value !== 50) {
        filters.push(`brightness(${brightness.value * 2}%)`);
      }

      if (saturation.value !== 50) {
        filters.push(`saturate(${saturation.value * 2}%)`);
      }

      if (contrast.value !== 50) {
        filters.push(`contrast(${contrast.value * 2}%)`);
      }

      if (blur.value !== 0) {
        filters.push(`blur(${blur.value}px)`);
      }
      if (effect == 'shadow') {
        const initialDistance = 0.04; // Default distance for shadow effect
        const initailAngle    = 45; // Default angle for shadow effect
        const initailBlur     = 0.1; // Default blur for shadow effect
        let scaledDistance    = (isShadow && shadow && typeof shadow.distance != 'undefined' ? parseFloat(shadow.distance) : initialDistance) * Math.max(this.objectProps.Height, this.objectProps.Width);
        scaledDistance        = this.objectProps.type == 'image' && this.objectProps.ImageType == 'WhiteboxLogo' ? scaledDistance / 10 : scaledDistance;
        const radians         = ((isShadow && shadow && shadow.angle ? shadow.angle : initailAngle) * Math.PI) / 180;
        const shadowOffsetX   = scaledDistance * Math.cos(radians);
        const shadowOffsetY   = scaledDistance * Math.sin(radians);

        const newShadowValue =        `drop-shadow(
        ${shadowOffsetX}px
        ${shadowOffsetY}px
        ${(isShadow && shadow && (typeof shadow.blur !== 'undefined') ? shadow.blur : initailBlur) * 40}px
        ${isShadow && shadow && shadow.color ? shadow.color : '#846C63'})`;

        filters.push(newShadowValue); // Add new drop-shadow
      }

      if (effect == 'outline') {
        // console.log('adding outline effect')
        const initialDistance = 5; // Default distance for shadow effect
        const distance        = (isOutline && outline && typeof outline.distance != 'undefined' ? parseFloat(outline.distance) : initialDistance);
        const color           = this.objectProps.outline && this.objectProps.outline.color ? this.objectProps.outline.color : '#000';
        let divider           = 1;
        if (this.objectProps.ImageType == 'WhiteboxLogo') { divider = 5; }

        const newShadowValue = distance > 0 ? `drop-shadow(${distance / divider}px 0 0 ${color}) drop-shadow(-${distance / divider}px 0 0 ${color}) drop-shadow(0 ${distance / divider}px 0 ${color}) drop-shadow(0 -${distance / divider}px 0 ${color})` : '';
        // console.log('newShadowValue', newShadowValue);
        filters.push(newShadowValue); // Add new drop-shadow
      }
      let filterProperties = {
        '--vignetteSize':  `${500 - (4 * vignette.value)}%`,
        '--vignetteColor': `rgba(0,0,0,${vignette.value / 100})`,
      };

      if (filters.length > 0) {
        filterProperties.filter = filters.join(' ');
      }

      if (vignette.value === 0) {
        delete filterProperties['--vignetteSize'];
        delete filterProperties['--vignetteColor'];
      }

      const srcExtension = this.imageURL
        .substr(this.imageURL.lastIndexOf('.') + 1)
        .trim();

      if (srcExtension === 'svg' && this.objectProps.ImageType !== 'WhiteboxLogo') {
        filterProperties = {}; // Remove all filters for SVG
      }

      return Object.assign({}, basicImageProperties, filterProperties);
    },
    getImageStyles() {
      const hFlipped     = JSON.parse(this.isHFlipped);
      const vFlipped     = JSON.parse(this.isVFlipped);
      return {
        display:      'block',
        width:        '100%',
        height:       '100%',
        objectFit:    'fill',
        transform:    `scale(${hFlipped === true ? -1 : 1},${vFlipped === true ? -1 : 1})`,
        borderRadius: this.imageBorderRadius,
      };
    },
    getTintStyle() {
      let toReturn       = { display: 'none' };
      try {
        const { effects } = this;
        if (effects.tint.value > 0) {
          toReturn = {
            display:         'block', backgroundColor: effects.tint.color, opacity:         effects.tint.value / 100, borderRadius: this.imageBorderRadius,
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            overflow: 'hidden',
          };
        }
      } catch (ex) {
        console.log('Error in processing tint style @getTintStyle', ex.message);
      } finally {
        return toReturn;
      }
    },
    getVignetteStyle() {
      try {
        return {
          position: 'absolute', width:    '100%', top:      '0', bottom:   '0', overflow: 'hidden', borderRadius: this.imageBorderRadius,
        };
      } catch (ex) {
        console.log('Error in processing tint style @getTintStyle', ex.message);
        return {
          position: 'absolute', width:    '100%', top:      '0', bottom:   '0', overflow: 'hidden',
        };
      }
    },
    getTransformCSS() {
      const { rotateAngle } = this;
      return `scale(${this.objectProps.scaleX},${this.objectProps.scaleY}) rotate(${rotateAngle}deg)`;
    },
    getElementIndex() {
      if (this.isGroupChild) {
        return typeof this.elementIndex === 'number' ? this.elementIndex : -1;
      }
      return this.objectProps.elementIndex;
    },
    getClass() {
      return 'target';
    },
    getMaskStyle() {
      const distance = parseFloat(this.getBlurEdgesDistance);
      if (this.objectProps.effect !== 'blurEdges' || !this.generatedMask || Number.isNaN(distance)) {
        return {};
      }

      const blurDistance = Math.max(distance, 0);
      if (blurDistance === 0) {
        return {};
      }

      const maxSize = 130;
      const minSize = 40;

      const clampedDistance = Math.min(blurDistance, 100);
      const progress        = clampedDistance / 100;

      const size      = maxSize - (progress * (maxSize - minSize));
      const finalSize = `${size}%`;

      return {
        maskImage:          `url(${this.generatedMask})`,
        maskRepeat:         'no-repeat',
        maskPosition:       'center',
        maskSize:           `${finalSize} ${finalSize}`,
        maskOrigin:         'content-box',
        WebkitMaskImage:    `url(${this.generatedMask})`,
        WebkitMaskRepeat:   'no-repeat',
        WebkitMaskPosition: 'center',
        WebkitMaskSize:     `${finalSize} ${finalSize}`,
        WebkitMaskOrigin:   'content-box',
      };
    },
    getBlurEdgesDistance() {
      if (this.objectProps.effect !== 'blurEdges') {
        return '';
      }

      const defaultDistance = 6;
      const distance        = this.objectProps.blurEdges && typeof this.objectProps.blurEdges.distance !== 'undefined'
        ? parseFloat(this.objectProps.blurEdges.distance)
        : defaultDistance;

      return Number.isNaN(distance) ? defaultDistance : distance;
    },
  },
  created() {
    if (this.objectProps.cornerRadius == null) {
      this.$set(this.objectProps, 'cornerRadius', 0);
    }
    this.instanceId = uuid.v1();
    if (!this.objectProps.HighResV2Height || !this.objectProps.HighResV2Width) {
      this.loadHighResImage();
    }

    if (!this.objectProps.DefaultImageHeight || !this.objectProps.DefaultImageWidth) {
      this.loadDefaultImage();
    }
  },
  beforeMount() {

  },
  async mounted() {
    if (this.objectProps.ImageType == 'SVGImage') {
      if (this.$refs.svgDiv.getElementsByTagName('style').length > 0) {
        this.convertClassToInline();
      }
      this.setSvgColor();
    }
    if (this.objectProps.effect === 'blurEdges') {
      this.initMask();
    }
  },
  updated() {
    EventBus.$emit(ApplicationEventTypes.ObjectSelectionEvents.UPDATED);
  },
  methods: {
    async initMask() {
      const width  = this.width || 1000;
      const height = this.height || 1000;
      const key    = `${width}_${height}`;
      if (blurMaskCache.has(key)) {
        this.generatedMask = blurMaskCache.get(key);
        return;
      }
      this.generatedMask = await getBlurMaskBlob(width, height);
    },
    loadDefaultImage() {
      const defaultImageUrl  = new Image();
      defaultImageUrl.onload = () => {
        !this.objectProps.DefaultImageHeight && (this.objectProps.DefaultImageHeight = defaultImageUrl.height);
        !this.objectProps.DefaultImageWidth && (this.objectProps.DefaultImageWidth  = defaultImageUrl.width);
      };
      defaultImageUrl.src    = this.imageURL;
    },
    loadHighResImage() {
      const highResImage  = new Image();
      highResImage.onload = () => {
        !this.objectProps.HighResV2Height && (this.objectProps.HighResV2Height = highResImage.height);
        !this.objectProps.HighResV2Width && (this.objectProps.HighResV2Width = highResImage.width);
      };
      highResImage.src    = this.objectProps.HighResPath;
    },
    setSvgColor() {
      // const svgElement = document.getElementById(this.objectProps.Id).firstChild.firstChild;
      const svgElement = document.querySelector(`[id='${this.objectProps.Id}'] svg`);
      const paths      = svgElement ? svgElement.getElementsByTagName('path') : [];
      for (let i = 0; i < paths.length; i++) {
        let breakFill   = false;
        let breakStroke = false;
        if (paths[i].style.fill !== '') {
          this.objectProps.SvgProperty.DefaultColor = paths[i].style.fill;
          breakFill                                 = true;
        }
        if (paths[i].style.stroke !== '') {
          this.objectProps.SvgProperty.StrokeColor = paths[i].style.stroke;
          breakStroke                              = true;
        }
        if (breakFill && breakStroke) { break; }
      }
    },
    convertClassToInline() {
      const svgElement = document.getElementById(this.objectProps.Id).firstChild.firstChild;
      const paths      = svgElement.getElementsByTagName('path');
      for (let i = 0; i < paths.length; i++) {
        const { fill }      = getComputedStyle(paths[i]);
        paths[i].style.fill = fill;
      }
      this.objectProps.SvgProperty.content = svgElement.outerHTML;
    },
  },
};

</script>
<style lang="scss" scoped>
.svg-height > svg {
  float: left;
}

div.image-container .vignette-div:after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  width: var(--vignetteSize);
  height: var(--vignetteSize);;
  background: radial-gradient(ellipse at center, #00000000 0%, var(--vignetteColor) 100%);
}

div.tint-div {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.svg-height {
  height: inherit;
}

.anim {
  height: 100%;
  width: 100%;

  img {
    height: 100%;
    width: 100%;
  }
}
</style>
